declare let siteLocal;

export const getSiteLocal = () => {
    if (typeof siteLocal != "undefined")
        return siteLocal;
    return '';
};